// extracted by mini-css-extract-plugin
export var header = "_tw-1";
export var maskBottom = "_tw-6";
export var maskMiddle = "_tw-7";
export var maskTop = "_tw-5";
export var root = "_tw-0";
export var scrollDownButton = "_tw-3";
export var scrollDownButtonHidden = "_tw-4";
export var viewport = "_tw-2";